import { render, staticRenderFns } from "./VListItem.vue?vue&type=template&id=4e052807&lang=pug"
import script from "./VListItem.vue?vue&type=script&lang=js"
export * from "./VListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports